import { Checkbox, Stack, TableCell, TableRow } from "@mui/material";
import { types } from "api";
import { StyledButton } from "components/StyledButton";
import { Link } from "react-router-dom";
import { getPath, routes } from "routes";
import React from "react";

export interface StudentTableRowProps {
	selected: string[];
	onCheckboxClick: (event: React.MouseEvent<unknown>, userid: string) => void;
	row: types.User;
	labelId: string;
}

// const PREFIX = "GroupTableRow";

export const StudentTableRow = ({
	selected,
	row,
	onCheckboxClick,
	labelId,
}: StudentTableRowProps): JSX.Element => {
	const isSelected = (userid: string): boolean =>
		selected.indexOf(userid) !== -1;

	const isItemSelected = isSelected(row.userId);

	return (
		<TableRow hover role="checkbox" key={row.userId}>
			<TableCell padding="checkbox">
				<Checkbox
					checked={isItemSelected}
					data-testid="checkbox"
					inputProps={{ "aria-labelledby": labelId }}
					onClick={(event) => onCheckboxClick(event, row.userId)}
				/>
			</TableCell>
			<TableCell data-testid="firstName">
				<Stack direction="row" alignItems="center">
					{row.firstName}
				</Stack>
			</TableCell>
			<TableCell data-testid="lastName">{row.lastName}</TableCell>
			<TableCell data-testid="email">{row.email}</TableCell>
			<TableCell data-testid="yearLevel">{row.yearLevel}</TableCell>
			<TableCell data-testid="edit-action">
				<StyledButton
					variant="contained"
					color="primary"
					sx={{ marginRight: 2 }}
					component={Link}
					to={getPath(routes._.result._.viewResult, { userId: row.userId })}
				>
					VIEW REPORT
				</StyledButton>

				<StyledButton
					variant="contained"
					color="primary"
					sx={{ marginRight: 2 }}
					component={Link}
					to={getPath(routes._.result._.addEvaluation, {
						userId: row.userId,
					})}
				>
					ADD EVALUATION
				</StyledButton>
			</TableCell>
		</TableRow>
	);
};
